import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";

export const UpdateTarifSchema = z.object({
  label: z.string().min(1, i18nMessage("boParameters:tarifForm.labelRequired")),
  tarifIdToCopy: z.string().min(1, i18nMessage("boParameters:tarifForm.tarifRequired")),
  shouldFollowTarif: z.boolean(),
  changePercentage: z.number({ coerce: true }).optional(),
});

export type UpdateTarifFormData = z.infer<typeof UpdateTarifSchema>;

export const CreateTarifSchema = z.object({
  label: z.string().min(1, i18nMessage("boParameters:tarifForm.labelRequired")),
  tarifIdToCopy: z.string().min(1, i18nMessage("boParameters:tarifForm.tarifRequired")),
  shouldFollowTarif: z.boolean(),
  changePercentage: z.number({ coerce: true }).optional(),
});

export type CreateTarifFormData = z.infer<typeof CreateTarifSchema>;

export const buildCreateTarifDefaultValues = (defaultTarifId: string): CreateTarifFormData => ({
  label: "",
  tarifIdToCopy: defaultTarifId,
  shouldFollowTarif: false,
  changePercentage: 0,
});

export const ReassignCompanySchema = z.object({
  tarifId: z.string().min(1, i18nMessage("boParameters:tarifForm.tarifRequired")),
});

export type ReassignCompanyFormData = z.infer<typeof ReassignCompanySchema>;
